import { z } from 'zod';
import type { ProxyModifiedSnapshot } from '../types/proxy-modified-snapshot';
import { safeJsonParse } from './safe-json-parse';

const HttpHeaderValueSchema = z.union([z.string(), z.array(z.string())]);

export const HttpHeadersRecordSchema = z.record(
  z.string(),
  HttpHeaderValueSchema,
);

export const StringArraySchema = z.array(z.string());

export const ProxyModifiedSnapshotSchema = z.object({
  method: z.string(),
  url: z.string(),
  headers: HttpHeadersRecordSchema,
  body: z.string().optional(),
  statusCode: z.number().optional(),
  statusMessage: z.string().optional(),
}) satisfies z.ZodType<ProxyModifiedSnapshot>;

export function parseStoredJsonField<T>(
  schema: z.ZodType<T>,
  json: string | null | undefined,
): T | undefined {
  if (!json) {
    return undefined;
  }

  const parsed = safeJsonParse(json);
  if (parsed === undefined) {
    return undefined;
  }

  const result = schema.safeParse(parsed);
  return result.success ? result.data : undefined;
}
